import { Component, OnInit, Injectable } from '@angular/core';

import { Http } from '@angular/http';

import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

import { DomSanitizer, Meta, Title } from '@angular/platform-browser';

//declare let ga: Function;

@Injectable()
export class MarkLogicService {

  constructor(private http: Http) {
    console.log('MarkLogic Service is available...');
  }

  makeDopRequest(url: string) {
    return this.sendDopRequest(url);
  }

  private sendDopRequest(url: string) {
    return this.http.get(url)
  }

}

@Component({
  selector: 'app-alphalist',
  templateUrl: './alphalist.component.html',
  styleUrls: ['./alphalist.component.scss'],
  providers: [MarkLogicService]
})
export class AlphalistComponent implements OnInit {

  constructor(
      private ml: MarkLogicService,
      private _sanitizer: DomSanitizer,
      public http: Http,
      private route: ActivatedRoute,
      private router: Router,
      private meta: Meta,
      private titleService: Title
  ) { }

  sub;
  selectedLetter = '';
  alphaList: any[];
  otherList: any[];


  location = this.router;


  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.selectedLetter = this.route.snapshot.params['letter'];
      this.getDopAlpha(this.route.snapshot.params['letter']);
      this.getDopOther();


      this.setTitle(this.route.snapshot.params['letter']);

      this.meta.updateTag({ name: 'description', content: 'A list of Dictionary of Psychology terms starting with letter ' +  this.route.snapshot.params['letter'] });

      this.meta.updateTag({ property: 'og:title', content: 'Browse by ' + this.route.snapshot.params['letter'] + ' – APA Dictionary of Psychology' });
      this.meta.updateTag({ property: 'og:url', content: 'https://dictionary.apa.org/' });
      this.meta.updateTag({ property: 'og:image', content: 'http://www.apa.org/pubs/books/images/4311022-475.gif' });


      this.meta.updateTag({ name: 'twitter:title', content: 'Browse by ' + this.route.snapshot.params['letter'] + ' – APA Dictionary of Psychology'  });
      this.meta.updateTag({ name: 'twitter:url', content: 'https://dictionary.apa.org/' });
      this.meta.updateTag({ name: 'twitter:description', content: 'A list of Dictionary of Psychology terms starting with letter ' +  this.route.snapshot.params['letter'] });
      this.meta.updateTag({ name: 'twitter:card', content: 'summary' });
      this.meta.updateTag({ name: 'twitter:site', content: '@APA' });

      this.meta.removeTag('itemprop=name');
      this.meta.removeTag('itemprop=description');
      this.meta.removeTag('itemprop=image');

      this.meta.addTag({ itemprop: 'name', content: 'Browse by ' + this.route.snapshot.params['letter'] + ' – APA Dictionary of Psychology' });
      this.meta.addTag({ itemprop: 'description', content:  'A list of Dictionary of Psychology terms starting with letter ' +  this.route.snapshot.params['letter'] });
      this.meta.addTag({ itemprop: 'image', content: 'http://www.apa.org/pubs/books/images/4311022-475.gif' });

      //this.gasend('/browse/'+ this.route.snapshot.params['letter'], 'Browse by '+ this.route.snapshot.params['letter'] +' - APA Dictionary of Psychology', 'https://dictionary.apa.org/browse/'+ this.route.snapshot.params['letter'] );

    });
  }

  getDopAlpha(term): void {
    this.ml.makeDopRequest('https://x6t7fqryxa.execute-api.us-east-1.amazonaws.com/dev/getdopentries?q='+term+'&limit=5000')
        .subscribe(data => {
          this.alphaList = data.json()[1];
        });
  }

  getDopOther(): void {
    this.ml.makeDopRequest('https://x6t7fqryxa.execute-api.us-east-1.amazonaws.com/dev/getdopentries?q=&limit=54')
        .subscribe(data => {
          this.otherList = data.json()[1];
        });
  }

  changeModel(alpha) {
    this.router.navigate(['/', this.slugifyTerm(alpha) ]);

    var element = document.getElementById("headerContentSlim");
    element.scrollIntoView();
  }

  scrollIntoView() {
    var element = document.getElementById("headerContentSlim");
    element.scrollIntoView();
  }

  slugifyTerm(term) {

    var trans1 = String(term).replace(/<[^\w\s–\-]+>/g, '').toLowerCase();
    var trans2 = String(trans1).replace(/\’/g, '');
    var trans3 = String(trans2).replace(/\s/g, '-');
    var trans4 = String(trans3).replace(/\-\(.*\)$/, '');
    var trans5 = String(trans4).replace(/[′]/g, '');
    var trans6 = String(trans5).replace(/\./g, '');
    var trans7 = String(trans6).replace(/\*/g, '');

    var trans8 = String(trans7).replace(/[é]/g, 'e');
    var trans9 = String(trans8).replace(/[è]/g, 'e');
    var trans10 = String(trans9).replace(/[ê]/g, 'e');
    var trans11 = String(trans10).replace(/[ë]/g, 'e');
    var trans12 = String(trans11).replace(/[ö]/g, 'o');
    var trans13 = String(trans12).replace(/[/]/g, '');
    var trans14 = String(trans13).replace(/[á]/g, 'a');
    var trans15 = String(trans14).replace(/[à]/g, 'a');
    var trans16 = String(trans15).replace(/[ä]/g, 'a');
    var trans17 = String(trans16).replace(/[š]/g, 's');
    var trans18 = String(trans17).replace(/[ü]/g, 'u');
    var trans19 = String(trans18).replace(/[…]/g, '');
    var trans20 = String(trans19).replace(/[&]/g, '');
    var trans21 = String(trans20).replace(/[→]/g, '');
    var trans22 = String(trans21).replace(/[+]/g, '-plus');
    var trans23 = String(trans22).replace(/[Š]/g, 's');
    var trans24 = String(trans23).replace(/[δ]/g, '-delta');
    var trans25 = String(trans24).replace('x̄', 'x-bar');
    var trans26 = String(trans25).replace(/[’]/g, '');
    var trans27 = String(trans26).replace(/[,]/g, '');
    var trans28 = String(trans27).replace(/[–]/g, '-');
    var trans29 = String(trans28).replace(/[=]/g, '-');
    var trans30 = String(trans29).replace(/[\(\)]/g, '');
    var trans31 = String(trans30).replace(/\-\-/g, '-');
    var trans32 = String(trans31).replace(/‘/g, '');
    var trans33 = String(trans32).replace(/:/g, '');
    return trans33
  }

  public setTitle( newTitle: string) {
    this.titleService.setTitle( 'Browse by ' + newTitle + ' – APA Dictionary of Psychology');
  }

/*  public gasend(gaPage, gaTitle, gaLocation){
    ga('create',"UA-10493335-13","auto");
    ga('send', {
      hitType: 'pageview',
      page: gaPage,
      title: gaTitle,
      location : gaLocation
    });
  }*/

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/DOP-StaticContent-Prod-Deploy/src/app/alphalist/alphalist.component.ts